import CheckboxToggler from "../lib/checkbox-toggler";

$.widget.bridge('checkboxToggler', CheckboxToggler);
